var FULL_PROGRESS_PERCENTAGE = 100;
var END_PROGRESS_PERCENTAGE = 85;
var PROGRESS_STEP = 5;
var PROGRESS_INTERVAL_MS = 60;

export { END_PROGRESS_PERCENTAGE, FULL_PROGRESS_PERCENTAGE, PROGRESS_INTERVAL_MS, PROGRESS_STEP };
//# sourceMappingURL=constants.js.map
